import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../../../components/Header";
import Footer from "../../../../components/Footer";
import "../../styleAllServices.css";
import mossImg from "../../../../assets/img/lawn-disease-close-up-damaged-grass.jpg";
import lawnImg from "../../../../assets/img/lawn-damage-patchy-grass.jpg";

export default function MossControl() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    let linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) { linkTag.setAttribute("href", canonicalUrl); }
    else {
      linkTag = document.createElement("link");
      linkTag.setAttribute("rel", "canonical");
      linkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(linkTag);
    }
    document.title = "Moss Control Vancouver | Lawn Moss Treatment & Prevention | BUR-HAN";
    const desc = "Expert moss control in Vancouver. Treat and prevent lawn moss with BUR-HAN's proven fertilization, liming and aeration programs. Pesticide-free. Free quote: 604-983-2687";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) { metaDesc.setAttribute("content", desc); }
    else {
      metaDesc = document.createElement("meta");
      metaDesc.setAttribute("name", "description");
      metaDesc.setAttribute("content", desc);
      document.head.appendChild(metaDesc);
    }
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) { ogTitle.setAttribute("content", document.title); }
    else {
      ogTitle = document.createElement("meta");
      ogTitle.setAttribute("property", "og:title");
      ogTitle.setAttribute("content", document.title);
      document.head.appendChild(ogTitle);
    }
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) { ogDesc.setAttribute("content", desc); }
    else {
      ogDesc = document.createElement("meta");
      ogDesc.setAttribute("property", "og:description");
      ogDesc.setAttribute("content", desc);
      document.head.appendChild(ogDesc);
    }
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="serviceItemsHeader">
        <h1 data-aos="zoom-in">Moss Control Vancouver</h1>
      </div>
      <div className="serviceItemsMain">
        <h2 data-aos="fade-down">
          "Reclaim your lawn from moss — for good."
        </h2>
        <hr />
        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-right">
            <img loading="lazy" src={mossImg}
              alt="Close-up of moss-damaged lawn in Vancouver showing patchy grass and thick moss growth"
              title="Lawn Moss Damage in Vancouver — BUR-HAN Moss Control"
            />
          </div>
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">Why Is My Lawn Full of Moss?</h3>
            <p>
              Moss is one of the most common lawn problems across Greater Vancouver. It thrives in exactly the conditions Vancouver lawns often face: shade, acidic soil, compaction, poor drainage, and low fertility. Moss is a symptom, not the root cause — which is why moss killers alone never provide a permanent fix.
            </p>
            <p>
              BUR-HAN's moss control program addresses the underlying conditions that allow moss to take hold. We combine targeted treatments with a multi-step corrective program that changes the soil environment so grass can compete and moss cannot.
            </p>
          </div>
        </section>
        <section className="section-container">
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">Our Moss Control Approach</h3>
            <ul>
              <li><strong>Moss treatment:</strong> Application of ferrous sulphate or iron-based treatments to kill existing moss quickly and safely.</li>
              <li><strong>Dethatching:</strong> Removal of dead moss and thatch that is smothering your grass and preventing recovery.</li>
              <li><strong>Aeration:</strong> Core aeration relieves compaction and improves drainage — removing two key conditions that moss loves.</li>
              <li><strong>Liming:</strong> Raising soil pH from acidic to neutral makes the soil inhospitable to moss and greatly improves grass health.</li>
              <li><strong>Overseeding:</strong> Once conditions are corrected, overseeding fills bare areas and establishes dense grass that outcompetes moss.</li>
              <li><strong>Fertilization program:</strong> Regular fertilization builds strong, thick turf that leaves no room for moss to re-establish.</li>
            </ul>
           
          </div>
          <div className="image-container px-5" data-aos="fade-left">
            <img loading="lazy" src={lawnImg}
              alt="Patchy Vancouver lawn with moss damage requiring professional moss control treatment"
              title="Patchy Lawn Caused by Moss — Requires Professional Treatment"
            />
          </div>
        </section>

        <section className="lawnCareLinks" data-aos="fade-up">
          <h2>More Residential Lawn Care Services</h2>
          <div className="lawnCareLinks-grid">
      <a href="/services/residential-lawn-care">
        <strong>Residential Lawn Care</strong>
        <span>All lawn care services</span>
      </a>
      <a href="/services/residential-lawn-care/liming">
        <strong>Lawn Liming</strong>
        <span>Soil pH correction</span>
      </a>
      <a href="/services/residential-lawn-care/organic-weed-control">
        <strong>Organic Weed Control</strong>
        <span>Pesticide-free weed management</span>
      </a>
      <a href="/services/residential-lawn-care/topdressing">
        <strong>Topdressing</strong>
        <span>Compost & soil improvement</span>
      </a>
      <a href="/services/residential-lawn-care/overseeding">
        <strong>Overseeding</strong>
        <span>Thicken & repair your lawn</span>
      </a>
          </div>
        </section>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready to elevate your outdoor experience?</h3>
                <p>Fill out our Get a Quote page and let BUR-HAN assess your moss problem and build a custom treatment plan for your Vancouver lawn.</p>
              </div>
              <div className="col-md-6">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">Get A Quote</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
